const GeneralReports = requireAuth => [
  {
    path: '/general-reports',
    name: 'GeneralReports',
    component: () => import('./views/GeneralReports'),
    beforeEnter: requireAuth
  },
  {
    path: '/fuel-report',
    name: 'FuelReport',
    component: () => import('./views/fuelReport/FuelReport'),
    beforeEnter: requireAuth
  }
]

export default GeneralReports



// WEBPACK FOOTER //
// ./src/modules/generalReports/routes.js